import classNames from "classnames";
import { IconProps } from "../types";
import { asIcon } from "../utils/library";

const Close = ({ className, height = "19px", width = "20px" }: IconProps) => {
    const classes = classNames("closeIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 20 19"
            focusable="false"
            aria-label="close"
        >
            <polygon points="20 0.01 17.6 0 10 7.6 2.4 0 0 0.01 8.79 8.81 0 17.6 2.44 17.57 10 10.02 17.56 17.57 20 17.6 11.21 8.81 20 0.01" />
        </svg>
    );
};

const IconClose = asIcon(Close);
export default IconClose;
